import type { Address } from '@solana/kit';

import { DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ADDRESS } from '../generated/dopplerLaunchHookV1/index.js';

/** Default Doppler launch hook v1 program for devnet deployments. */
export const DEVNET_DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ID: Address =
  DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ADDRESS;

export const DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ID =
  DEVNET_DOPPLER_LAUNCH_HOOK_V1_PROGRAM_ID;

export const SEED_DOPPLER_LAUNCH_HOOK_V1_CONFIG = 'cosigner_hook_config';
export const MAX_COSIGNERS = 32;

export const GATE_EXPIRY_DISABLED = 0;
export const GATE_EXPIRY_UNIX_TIMESTAMP = 1;
export const GATE_EXPIRY_SLOT = 2;
export const GATE_EXPIRY_PAYLOAD_VERSION = 1;
export const GATE_EXPIRY_HEADER_LEN = 10;
export const GATE_EXPIRY_PAYLOAD_LEN = 42;

export const DYNAMIC_FEE_SCHEDULE_MAGIC = new Uint8Array([
  0x44, 0x46, 0x45, 0x45, 0x56, 0x31, 0x5f, 0x5f,
]);
export const DYNAMIC_FEE_SCHEDULE_VERSION = 1;
export const DYNAMIC_FEE_SCHEDULE_LEN = 32;
export const DYNAMIC_FEE_SCHEDULE_HEADER_LEN = 16;
export const DYNAMIC_FEE_SCHEDULE_MAX_BPS = 10_000;
